import { render, staticRenderFns } from "./AccountsViewTabBilling.vue?vue&type=template&id=725eb9d2"
import script from "./AccountsViewTabBilling.vue?vue&type=script&lang=js"
export * from "./AccountsViewTabBilling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports